import { useContext, useMemo } from 'react';
import { TProductSelectorSelectedData } from '../../../types/productSelector.types';
import { CustomFormContext } from '../../customFormContextProvider';

const findPreselectedSeriesAndModels = (productList, isShowHideOtherFields): TProductSelectorSelectedData => {
  const line = productList[0];
  const series = line?.series?.length === 1 ? line.series[0] : null;
  const models = series && series?.models?.length === 1 ? series.models[0] : null;

  const isLineHidden = isShowHideOtherFields && line;
  const isSeriesHidden = isShowHideOtherFields && series;

  return {
    defaultSelectedLine: line?.titleUrl,
    defaultSelectedSeries: series?.titleUrl,
    defaultSelectedModel: models?.titleUrl,
    isLineHidden,
    isSeriesHidden,
  };
};

const useDefaultSelectedProduct = (editorProductList) => {
  const customFormContext = useContext(CustomFormContext);

  const defaultSelectedData = useMemo(() => {
    const isEnablePreSelection = customFormContext?.params?.enablePreselection === '1';
    const isShowHideOtherFields = customFormContext?.params?.showHideOtherFields === '1';
    const isDefaultLine = editorProductList && editorProductList.length === 1;
    if (isEnablePreSelection && isDefaultLine) {
      const preselectedResult = findPreselectedSeriesAndModels(editorProductList, isShowHideOtherFields);
      return preselectedResult;
    }

    return null;
  }, [editorProductList]);
  return defaultSelectedData;
};

export default useDefaultSelectedProduct;
